/**
 * Resources storage
 *
 * @type {object}
 */
var resources = {}; // Requière tous les fichiers dans le dossier courant

var req = require.context('./', true, /^(.*\.(js$))[^.]*$/); // Charge tous les fichiers "ressource"


req.keys().forEach(function (key) {
  // check if require is the current file
  if (key === ".".concat(__filename) || key === "./".concat(__filename)) {
    return;
  }

  if (key === './index.js') {
    return;
  } // eslint-disable-next-line new-cap


  var resource = new (req(key).default)();
  var alias = resource.alias;

  if (resources[alias] !== undefined) {
    throw new Error("\"".concat(alias, "\" is used by multiple resource and must be unique !"));
  }

  resources[alias] = resource;
});
/**
 * Obtient l'instance d'une ressource (entité) dans la collection
 *
 * @param {string} alias
 *
 * @return {null|Resource}
 */

export default function getResource(alias) {
  var displayApiNotification = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (typeof alias !== 'string' || !resources.hasOwnProperty(alias)) {
    throw new Error("The resource ".concat(alias, " was not found, available are ").concat(Object.keys(resources).join(', ')));
  }

  if (!displayApiNotification) {
    resources[alias].disableApiNotification();
  }

  return resources[alias];
}